"use client";

import Link from "next/link";
import Image from "next/image";
import { Home, AlertTriangle, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="sk">
      <body>
        <div className="min-h-screen flex flex-col items-center justify-center px-4 py-12 text-center bg-background">
          <div className="max-w-md mx-auto space-y-8">
            {/* Logo a hlavný nadpis */}
            <div className="space-y-4">
              <div className="flex justify-center">
                <div className="relative">
                  <Image
                    src="/logo.png"
                    alt="ZOH 2026 Logo"
                    width={80}
                    height={80}
                    className="h-20 w-auto rounded-full border-4 border-destructive shadow-lg"
                  />
                </div>
              </div>
              <div className="flex items-center justify-center gap-2">
                <AlertTriangle className="h-6 w-6 text-destructive" />
                <h1 className="text-4xl font-bold tracking-tight text-foreground">
                  Kritická chyba
                </h1>
              </div>
              <p className="text-lg text-muted-foreground">
                Vyskytla sa vážna chyba, ktorá znemožňuje beh aplikácie.
              </p>
            </div>

            {/* Error detail */}
            <div className="space-y-4">
              <div className="text-6xl font-bold text-destructive/20">500</div>
              <div className="bg-destructive/10 border border-destructive/30 rounded-lg p-4">
                <p className="text-sm text-muted-foreground">
                  Aplikácia sa nemôže načítať kvôli kritickej chybe.
                </p>
                {process.env.NODE_ENV === "development" && error.digest && (
                  <p className="text-xs text-muted-foreground mt-2">
                    Error ID: {error.digest}
                  </p>
                )}
              </div>
            </div>

            {/* Akčné tlačidlá */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button onClick={reset} size="lg" className="w-full sm:w-auto">
                Reštartovať aplikáciu
              </Button>
              <Button
                variant="outline"
                size="lg"
                className="w-full sm:w-auto"
                asChild
              >
                <Link href="/" className="flex items-center gap-2">
                  <Home className="h-4 w-4" />
                  Domov
                </Link>
              </Button>
            </div>

            {/* Kontakt na podporu */}
            <div className="border-t pt-8">
              <p className="text-sm text-muted-foreground mb-4">
                Ak problém pretrváva, kontaktujte technickú podporu:
              </p>
              <Button variant="ghost" size="sm" asChild>
                <Link
                  href="mailto:roman.farki@gmail.com?subject=ZOH%202026%20-%20Kritick%C3%A1%20chyba&body=Pop%C3%AD%C5%A1te%20pros%C3%ADm%20ak%C3%A1%20str%C3%A1nka%20sp%C3%B4sobila%20chybu%20a%20%C4%8Do%20ste%20robili,%20ke%C4%8F%20k%20nej%20do%C5%A1lo."
                  className="flex items-center gap-2 text-destructive hover:text-destructive"
                >
                  <Mail className="h-4 w-4" />
                  Nahlásiť chybu
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
